<template>
  <div>
    <multiselect
      :value="input"
      :placeholder="placeholder"
      :selectLabel="selectLabel"
      :deselectLabel="deselectLabel"
      :preserveSearch="isResetAfter"
      :options="options"
      :disabled="isDisabled"
      :show-labels="false"
      :multiple="true"
      :custom-label="customlabel"
      :close-on-select="false"
      :clear-on-select="false"
      :class="{ 'is-invalid': isError ? 1 : 0 }"
      track-by="th"
      @select="onSelected"
      @remove="onRemoved"
    >
      <span slot="noOptions">ไม่พบข้อมูล</span>
      <span slot="noResult">ไม่พบข้อมูลที่ค้นหา</span>
    </multiselect>
  </div>
</template>

<script>
// import ilbs
import Multiselect from 'vue-multiselect'

export default {
  name: 'AttributeSelectorMultiComponent',
  components: {
    Multiselect,
  },
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    options: {
      type: Array,
      default: null,
    },
    isError: {
      type: Boolean,
      default: false,
    },
    preserveSearch: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: 'ระบุข้อมูลเพื่อค้นหา',
    },
    selectLabel: {
      type: String,
      default: 'เลือก',
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    deselectLabel: {
      type: String,
      default: '',
    },
    noResult: {
      type: String,
      default: 'ไม่พบข้อมูลที่ค้นหา',
    },
  },
  async mounted() {},
  data() {
    return {
      optionValues: [],
      isResetAfter: false,
    }
  },
  computed: {
    input() {
      // console.log('input', this.value)
      if (
        this.value &&
        this.value.length > 0 &&
        this.value[0] &&
        (this.value[0].en !== '' || this.value[0].th !== '')
      ) {
        return this.value
      }
      return []
    },
  },
  watch: {
    preserveSearch: function(val) {
      if (val) {
        this.onReset()
      }
    },
  },
  methods: {
    customlabel({ en, th }) {
      return (en && en !== undefined) || (th && th !== undefined)
        ? `${th}  :  ${en}`
        : ''
    },
    onReset() {
      this.options = []
      this.isResetAfter = true
    },
    onSelected(val) {
      const oldValue = this.input
      const newValue = [...oldValue, val]
      this.$emit('input', newValue)
    },
    onRemoved(val) {
      const oldValue = this.input
      const newValue = oldValue.filter(it => it.th !== val.th)
      this.$emit('input', newValue)
    },
  },
}
</script>
